module.exports = __webpack_public_path__ + "vision.2758f55a209b0936b7f9.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/agencehoffman/Desktop/Workspace/catherinet/src/app/assets/images/vision.jpg
// module id = ../../../../../src/app/assets/images/vision.jpg
// module chunks = main